import { api } from "../client";
import {
  FavoritePositionExtraFields,
  FavoritePositionFields,
  PartialFavoritePositionExtraFields,
  PartialFavoritePositionFields,
} from "../schema/FavoritesPosition";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<
  FavoritePositionFields,
  FavoritePositionExtraFields
>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialFavoritePositionFields,
  PartialFavoritePositionExtraFields
>;

export const getFavoritePositions = async (config?: ApiRequestConfig) => {
  return api.get<FavoritePositionFields, FavoritePositionExtraFields>(
    "favorite_positions",
    config
  );
};
export const getFavoritePosition = (id: number, config?: ApiRequestConfig) => {
  return api.get<FavoritePositionFields, FavoritePositionExtraFields>(
    `favorite_positions/${id}`,
    config
  );
};

export const createFavoritePosition = (config: ApiRequestConfigMutate) => {
  return api.create<FavoritePositionFields, FavoritePositionExtraFields>(
    "favorite_positions",
    config
  );
};

export const updateFavoritePosition = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialFavoritePositionFields,
    PartialFavoritePositionExtraFields
  >(`favorite_positions/${id}`, config);
};
export const deleteFavoritePosition = (id: number) => {
  return api.remove<FavoritePositionFields, FavoritePositionExtraFields>(
    `favorite_positions/${id}`
  );
};
